/* =========================================================================
   SAMSARA — SECTION-HOME-VOICES.JS
   Sprint 6 polish — Mobile carousel nav. Prev/next + dots indicator.
   Visible doar <768px (carousel mode); desktop e grid 2x2.
   ========================================================================= */

(function () {
  'use strict';

  function init(section) {
    const list = section.querySelector('.home-voices__list');
    const prevBtn = section.querySelector('[data-voices-prev]');
    const nextBtn = section.querySelector('[data-voices-next]');
    const dots = section.querySelectorAll('[data-voices-dot]');
    const items = section.querySelectorAll('.home-voices__item');
    if (!list || !items.length) return;

    function getItemWidth() {
      const first = items[0];
      if (!first) return 0;
      const rect = first.getBoundingClientRect();
      const gap = parseFloat(getComputedStyle(list).gap) || 0;
      return rect.width + gap;
    }

    function getActiveIndex() {
      const w = getItemWidth();
      if (w === 0) return 0;
      return Math.round(list.scrollLeft / w);
    }

    function setActiveDot(index) {
      dots.forEach(function (d, i) {
        d.classList.toggle('home-voices__dot--active', i === index);
      });
    }

    function scrollToIndex(index) {
      const clamped = Math.max(0, Math.min(index, items.length - 1));
      const w = getItemWidth();
      list.scrollTo({ left: w * clamped, behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollToIndex(getActiveIndex() - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollToIndex(getActiveIndex() + 1);
      });
    }

    // Sync dots on manual scroll (debounced)
    let scrollTimer = null;
    list.addEventListener('scroll', function () {
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        setActiveDot(getActiveIndex());
      }, 80);
    }, { passive: true });
  }

  function bootAll() {
    document.querySelectorAll('[data-home-voices]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
})();
